// extracted by mini-css-extract-plugin
export default {"period":"Period_period__f74q8","isLast":"Period_isLast__my5Xl","days":"Period_days__l8-G4","dates":"Period_dates__NHzMD"};